import SettingsPageContainer from './SettingsPageContainer';
export default SettingsPageContainer;
